import ReferralModal from '@features/games/profile/referral/referral';
export default ReferralModal;
